<template>
  <div v-if="inputValue">
    <MasterMultipleAreaBase
      v-model="inputValue"
      :title="
        $t('jd.jd_jdcom-product') +
        (editMode ? $t('common.common_edit') : $t('common.common_register'))
      "
      :width="width"
      :pageData="pageData"
      @complete="complete()"
      @clicksubTextButton="jdRelatedProductDialogInfo.register = true"
    >
      <template v-slot:[pageData[0].name]>
        <v-container fluid class="pa-0">
          <v-row no-gutters class="mx-10 my-3">
            <v-col cols="5">
              <InputFormNew
                v-model="inputData.jdProductInfoLine1"
                :detail="items.jdProductInfoLine1"
                :titleCols="5"
                :contentsCols="5"
              />
            </v-col>
            <v-col cols="7">
              <InputFormNew
                v-model="inputData.jdProductInfoLine2"
                :detail="items.jdProductInfoLine2"
                :titleCols="3"
                :contentsCols="inputFormStyle.contentsCols"
              >
                <template #invisibleFlg="{ item }">
                  <v-row>
                    <v-checkbox
                      class="checkbox-area"
                      v-model="item.invisibleFlg"
                      :true-value="0"
                      :false-value="1"
                      :label="$t('product.product_indicate')"
                    ></v-checkbox>
                  </v-row>
                </template>
              </InputFormNew>
            </v-col>
          </v-row>
        </v-container>
      </template>

      <template v-slot:[pageData[1].name]>
        <div>
          <div class="jdRelatedProductTable">
            <v-data-table
              :headers="tableHeaders"
              :items="inputData.jdproductRelatedProductList"
              :item-key="itemKey"
              :items-per-page="-1"
              hide-default-footer
              :no-data-text="$t('common.common_not-register')"
              class="rounded-lg"
            >
              <template #[`item.jdRelatedProductName`]="{ item }">
                <div class="my-2" v-if="item.product">
                  {{ item.product.nameJp }} <br />
                  {{ item.product.nameCn }} <br />
                </div>
                <div v-else class="my-2">{{ '-' }}</div>
              </template>
              <template #[`item.jdRelatedProductSupplier`]="{ item }">
                <div class="my-2" v-if="item.product">
                  {{ getSupplierName(item.product.supplierId) }}
                </div>
                <div v-else class="my-2">-</div>
              </template>
              <template #[`item.price`]="{ item }">
                <div class="my-2" v-if="item.price">
                  {{
                    formatPrice(Number(item.price)).toLocaleString() +
                    getCurrencyUnitName
                  }}
                </div>
                <div v-else class="my-2">-</div>
              </template>
              <template #[`item.deleteJdRelatedProduct`]="{ item }">
                <WhiteButton
                  :text="$t('common.input_delete')"
                  height="32px"
                  width="48px"
                  @click.native="deleteJdRelatedProduct(item)"
                />
              </template>
            </v-data-table>
          </div>
        </div>
      </template>
    </MasterMultipleAreaBase>
    <JdRelatedProductDialog
      v-model="jdRelatedProductDialogInfo.register"
      :jdRelatedProductData="inputData.jdproductRelatedProductList"
      @complete="addJdRelatedProduct"
      :selectedPlatform="
        editMode ? getPlatform() : inputData.jdProductInfoLine1.platform
      "
    />
  </div>
</template>
<script>
import MasterMultipleAreaBase from '@/components/layouts/Dialogs/Master/MasterMultipleAreaBase'
import { InputFormNew } from '@/components/items'
import { mapActions, mapGetters } from 'vuex'
import _cloneDeep from 'lodash/cloneDeep'
import { supplierUtil, commonUtil, currencyUtil, platformUtil } from '@/util'
import JdRelatedProductDialog from './JdRelatedProductDialog/JdRelatedProductDialog'
import { WhiteButton } from '@/components/items'

export default {
  components: {
    MasterMultipleAreaBase,
    InputFormNew,
    JdRelatedProductDialog,
    WhiteButton
  },
  props: {
    value: { default: false },
    width: { default: '1166px' },
    jdProductData: {
      type: Object,
      require: false,
      default: () => ({})
    },
    editMode: {
      type: Boolean,
      require: false,
      default: false
    }
  },
  data: () => ({
    inputFormStyle: {
      titleCols: 4,
      contentsCols: 7,
      inputItemHeight: '32px'
    },
    jdRelatedProductDialogInfo: {
      register: false
    },
    inputData: {},
    pageData: [
      {
        title: 'jd.jd_jdcom-product-info',
        name: 'jdProductInfo',
        items: [],
        itemKey: ''
      },
      {
        title: 'common.common_product-register',
        name: 'jdRelatedProduct',
        subText: 'product.product_add-registered-products',
        items: [],
        itemKey: ''
      }
    ],
    items: {
      jdProductInfoLine1: [
        {
          name: 'jdproductNumber',
          text: 'jd.jd_jdcom-product-number',
          required: true,
          cols: Math.ceil(4),
          placeholder: '0000000000'
        },
        {
          name: 'platform',
          text: 'jd.jd_jdcom-store',
          component: 'SelectPlatformECName',
          cols: Math.ceil(4),
          required: true
        },
        {
          name: 'sku',
          text: 'jd.jd_jdcom-sku-id',
          cols: Math.ceil(4),
          placeholder: '0000000000'
        }
      ],
      jdProductInfoLine2: [
        {
          name: 'name',
          text: 'jd.jd_delivery-request-product-name',
          required: true
        },
        {
          name: 'invisibleFlg',
          text: 'product.product_display-setting',
          cols: Math.ceil(4)
        }
      ]
    },
    itemKey: 'jdRelatedProductId',
    supplierList: [],
    headers: [
      {
        text: 'common.product_product-name',
        value: 'jdRelatedProductName',
        sortable: false,
        width: '50%'
      },
      {
        text: 'product.product_supplier',
        value: 'jdRelatedProductSupplier',
        sortable: false,
        width: '19%',
        align: 'center'
      },
      {
        text: 'product.product_registration-quantity',
        value: 'quantity',
        sortable: false,
        width: '11%',
        align: 'center'
      },
      {
        text: 'jd.jd_jdcom-related-product-price',
        value: 'price',
        sortable: false,
        width: '11%',
        align: 'center'
      },
      {
        text: 'payment.payment_operation',
        value: 'deleteJdRelatedProduct',
        sortable: false,
        width: '9%',
        align: 'center'
      }
    ]
  }),

  created() {
    this.init()
    this.getSupplierList()
  },

  methods: {
    ...mapGetters('Common', [
      'getCountryJpFromState',
      'getCurrencyJpFromState'
    ]),
    ...mapActions('Jdproduct', ['registerJdproduct', 'editJdproduct']),
    ...mapActions('Supplier', ['getSuppliersFromApi']),
    ...mapGetters('Supplier', ['getSuppliersFromState']),

    async getSupplierList() {
      await this.getSuppliersFromApi()
      this.supplierList = this.getSuppliersFromState()
    },
    getSupplierName(supplierId) {
      const supplier = this.supplierList.find(
        (element) => element.supplierId === supplierId
      )
      return supplier ? supplier.name : ''
    },
    formatPrice(price) {
      return commonUtil.formatPrice(price)
    },
    getPlatform() {
      const platform = platformUtil.getPlatformById(
        this.jdProductData.platformId
      )
      return {
        label: platform.name,
        value: platform.platformId,
        platformCountryId: platform.platformCountryId
      }
    },
    async init() {
      supplierUtil.getSupplier()
      const formatData = _cloneDeep(this.jdProductData)
      // 新規登録の際に「表示する」項目のダイアログ初期値を0(表示する)で設定
      if (!Object.keys(formatData).length) {
        formatData.invisibleFlg = 0
      }
      if (this.editMode) {
        this.items.jdProductInfoLine1 = [
          {
            name: 'jdproductNumber',
            text: 'jd.jd_jdcom-product-number',
            required: true,
            cols: Math.ceil(4),
            placeholder: '0000000000'
          },
          {
            name: 'platform',
            text: 'jd.jd_jdcom-store',
            component: 'text',
            cols: Math.ceil(4)
          },
          {
            name: 'sku',
            text: 'jd.jd_jdcom-sku-id',
            cols: Math.ceil(4),
            placeholder: '0000000000'
          }
        ]
      }

      let platformInputData = {}
      if (this.editMode && formatData.platformId) {
        platformInputData = this.getPlatform().label
      } else if (this.editMode && !formatData.platformId) {
        platformInputData = ''
      }

      this.inputData = {
        jdproductId: formatData.exProductId,
        jdProductInfoLine1: {
          jdproductNumber: formatData.exProductNumber,
          sku: formatData.sku,
          platform: platformInputData
        },
        jdProductInfoLine2: {
          name: formatData.name,
          invisibleFlg: formatData.invisibleFlg
        },
        jdproductRelatedProductList: formatData.exProductRelatedProductList
          ? formatData.exProductRelatedProductList
          : []
      }
    },
    addJdRelatedProduct(registerJdRelatedProductData) {
      this.inputData.jdproductRelatedProductList = registerJdRelatedProductData
      this.jdRelatedProductDialogInfo.register = false
    },
    deleteJdRelatedProduct(jdRelatedProductItem) {
      this.inputData.jdproductRelatedProductList =
        this.inputData.jdproductRelatedProductList.filter(
          (jdRelatedProduct) => {
            return jdRelatedProduct != jdRelatedProductItem
          }
        )
    },
    async complete() {
      if (this.editMode) {
        this.inputData.id = this.inputData.jdproductId
      }
      const success = this.editMode
        ? await this.editJdproduct(this.inputData)
        : await this.registerJdproduct(this.inputData)

      if (success) {
        this.$emit('success')
      }
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    },
    tableHeaders() {
      const tmp = this.headers.map((ele) => {
        const params = { ...ele }
        params.text = this.$t(ele.text)
        return params
      })
      return tmp
    },
    getCurrencyUnitName() {
      const platformId = this.editMode
        ? this.jdProductData.platformId
        : this.inputData.jdProductInfoLine1.platform.value

      if (!platformId) return ''
      const platform = platformUtil.getPlatformById(platformId)
      const currency = currencyUtil.findCurrencyNameById(
        platformUtil.getCurrencyIdByPlatformCurrencyId(
          platform.platformCountryId
        )
      )
      return currency ? currency.unitName : ''
    }
  },

  watch: {
    inputValue: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal) this.init()
      }
    },
    'inputData.jdProductInfoLine1.platform': {
      deep: true,
      handler(newVal, oldVal) {
        if (oldVal) {
          const formatData = _cloneDeep(this.jdProductData)
          this.inputData.jdproductRelatedProductList =
            formatData.exProductRelatedProductList
              ? formatData.exProductRelatedProductList
              : []
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.jdRelatedProductTable {
  ::v-deep .v-data-table th {
    background-color: rgba(151, 198, 234, 0.1) !important;
    border-collapse: collapse;
    text-align: center !important;
    padding: 10px 0px !important;
    white-space: pre-wrap;
    background-color: #fafafb;
    border-bottom: 1px solid #d8d8d8;
    border-right: 1px solid #d8d8d8;
  }
  ::v-deep .v-data-table th:last-child {
    border-right: 0;
  }
  ::v-deep .v-data-table td {
    background-color: #f6f6f6;
    border-collapse: collapse;
    border-bottom: 1px solid #d8d8d8;
    border-right: 1px solid #d8d8d8;
    border-spacing: 0;
    margin: -1px;
  }
  ::v-deep .v-data-table td:last-child {
    border-right: 0;
  }
  ::v-deep .v-data-table tr:nth-child(odd) td {
    background-color: rgba(213, 213, 213, 0.1);
    border-collapse: collapse;

    border-bottom: 1px solid #d8d8d8;
    border-right: 1px solid #d8d8d8;
    border-spacing: 0;
    margin: -1px;
  }
  ::v-deep .v-data-table tr:nth-child(odd) td:last-child {
    border-right: 0;
  }
  ::v-deep .v-data-table tr:hover td {
    background-color: #eee;
  }
  ::v-deep .v-data-table tr:last-child td:first-child {
    border-radius: 0 0 0 7px;
  }
  ::v-deep .v-data-table tr:last-child td:last-child {
    border-radius: 0 0 7px 0;
  }
}

.checkbox-area {
  margin-left: 10px;
}
</style>
